<template>
  <template v-if="formErrorMessage">
    <div
      class="mb-4 rounded-md bg-red-200 p-2 text-sm text-red-800"
    >
      <p class="">
        {{ formErrorMessage }}
      </p>
    </div>
  </template>
  <form class="space-y-6" novalidate @submit="onFormSubmit">
    <FormInputText
      id="email"
      name="email"
      type="email"
      autocomplete="email"
      required
      label="Email Address"
    />

    <FormInputPassword
      id="password"
      name="password"
      label="Password"
      required
      autocomplete="current-password"
    />

    <div class="flex justify-end">
      <FormSubmitButton :is-loading="isSubmitting">
        Log In
      </FormSubmitButton>
    </div>
  </form>
</template>

<script setup lang="ts">
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import * as z from "zod"

const formErrorMessage = ref<string | null>(null)

const formSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: {
    email: "",
    password: "",
  },
})

const onFormSubmit = handleSubmit(async (values) => {
  formErrorMessage.value = null
  try {
    await passwordLogIn(values)
  } catch {
    formErrorMessage.value =
      "Failed to log in. Please check your username and password are correct."
  }
})
</script>
